import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LayoutWithBannerNavbarFooter } from 'layouts';
import './AssetsAllocation.scss';
import ultilitiesService from 'shared/util/ultilitiesService';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons';
import { injectIntl } from 'react-intl';
import {
  SubTitle, NWDonutChart, BottomNav, ItemList, RiskStatus,
} from 'components';
import { PATH, STORAGE_KEY } from 'shared/constants';
import getAssetAllocation from 'shared/redux/actions/assetAllocations';
import { toggleLanguage } from 'shared/redux/actions';
import { getAllFunds } from 'shared/redux/actions/fundFactsheet';
import background from 'assets/images/risk-profile-bg.png';
import arrowWhite from 'assets/icons/nextWhite.svg';
import {

  getRTL, getIsinCodes, getIsinFromFundFactsheet,
} from 'shared/redux/selectors';
import { eventAssetAllocationLooksGood, eventAssetAllocationProductOverview } from 'components/TrackEvent/constEvent';
import trackEvent from 'components/TrackEvent/TrackEvent';

const statusBarClass = 'status-bar--asset-allocation';

class AssetsAllocation extends Component {
  state = {
    isAssetAllocation: false,
  }

  componentDidMount() {
    document.body.classList.add(statusBarClass);
    const { onGetAssetAllocation, onGetFunds } = this.props;
    onGetAssetAllocation()
      .then((res) => {
        onGetFunds(res.isinCodes).then(() => {
          this.setState({ isAssetAllocation: true });
        });
      });
  }

  componentWillUnmount() {
    document.body.classList.remove(statusBarClass);
  }

  goBack = () => {
    // this.props.history.goBack();
    this.props.history.push(PATH.INVESTMENT_SUMMARY);
  };

  handleItemClick = (item) => {
    const {
      assetAllocations: {
        tacticleAsset,
      },
      isinFromFactsheet,
    } = this.props;

    // const fundsISIN = tacticleAsset.filter(i => i.isinCode).map(i => i.isinCode);
    const fundsISIN = tacticleAsset.filter(i => isinFromFactsheet.includes(i.isinCode)).map(i => i.isinCode);
    // console.log('ISINs ', fundsISIN);
    if (item.isinCode) {
      localStorage.setItem(STORAGE_KEY.CURRENT_PRODUCT_SLIDE, fundsISIN.indexOf(item.isinCode));
      if (fundsISIN.includes(item.isinCode)) this.props.history.push(PATH.PRODUCT_RECOMMENDATION);
    }
  };

  render() {
    const {
      assetAllocations: {
        assetAllocation,
        tacticleAsset,
      },
      currentLocale,
      history,
      isRtl,
      intl,
    } = this.props;

    const { isAssetAllocation } = this.state;

    return (
      <LayoutWithBannerNavbarFooter
        title="assetAllocation.title"
        leftButton={(<span className="arrow"><img src={arrowWhite} alt="arrow" /></span>)}
        onLeftClick={this.goBack}
        rightButton={ultilitiesService.locale(currentLocale)}
        onRightClick={() => history.push(PATH.LANGUAGE)}
        className="nw-page-assets-allocation"
        background={background}
        bannerText={<RiskStatus />}
        isRtl={isRtl}
        footerChildren={(
          <BottomNav
            rtl={isRtl}
            leftButton={intl.formatMessage({ id: 'products.title' })}
            onLeftClick={() => {
              this.props.history.push(PATH.PRODUCT_RECOMMENDATION);
              trackEvent(eventAssetAllocationProductOverview(currentLocale, intl.formatMessage({ id: 'products.title' })));
            }}
            rightButton={intl.formatMessage({ id: 'summary.looksGood' })}
            onRightClick={() => {
              // this.props.onGetFunds(this.props.isinCodes);
              this.props.history.push(PATH.GOAL_SUMMARY);
              trackEvent(eventAssetAllocationLooksGood(currentLocale, intl.formatMessage({ id: 'summary.looksGood' })));
            }}
            altStyle
          />
        )}
      >
        <p className={isRtl ? 'rtl' : ''}>{intl.formatMessage({ id: 'assetAllocation.description' })}</p>
        <SubTitle rtl={isRtl} title={intl.formatMessage({ id: 'assetAllocation.subTitle' })} />
        <div className={`nw-page-assets-allocation__chart ${isRtl ? 'rtl' : ''}`}>
          {isAssetAllocation && (
          <NWDonutChart
            isLegend
            legendAlign="right"
            innerRadius={50}
            outerRadius={60}
            pieName={intl.formatMessage({ id: 'assetAllocation.title' })}
            labelFill="#757679"
            // showPercentage
            data={assetAllocation}
            customLegend={props => (
              <ul className={isRtl ? 'rtl' : ''}>
                {props.payload.sort((a, b) => (b.payload.value - a.payload.value)).map((i, idx) => (
                  <li key={idx}>
                    <div>
                      <svg
                        className="recharts-surface"
                        width="8"
                        height="8"
                        viewBox="0 0 32 32"
                        style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
                      >
                        <path
                          fill={i.payload.color}
                          className="recharts-symbols"
                          transform="translate(16, 16)"
                          d="M16,0A16,16,0,1,1,-16,0A16,16,0,1,1,16,0"
                        />
                      </svg>
                      <span className="recharts-legend-item-text">{intl.formatMessage({ id: i.payload.code })}</span>
                    </div>
                    <span>{`${i.payload.value} %`}</span>
                  </li>
                ))}
              </ul>
            )}
            legendWidth={200}
          />
          )}
        </div>
        {/* <ItemList data={listing} /> */}
        <ItemList rtl={isRtl} data={tacticleAsset} onClick={this.handleItemClick} />

      </LayoutWithBannerNavbarFooter>
    );
  }
}

const mapStateToProps = state => ({
  assetAllocations: state.assetAllocations,
  isinCodes: getIsinCodes(state),
  isinFromFactsheet: getIsinFromFundFactsheet(state),
  currentLocale: state.rootReducer.language.locale,
  isRtl: getRTL(state.rootReducer),
});

const mapDispatchToProps = ({
  onGetAssetAllocation: getAssetAllocation,
  onSwitchLanguage: toggleLanguage,
  onGetFunds: getAllFunds,
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AssetsAllocation));
